import { Action } from 'app/store/actions';
import { Invoice } from 'types/invoice';
import { Order } from 'types/order';
export type InvoicePage = {
  showInvoiceNumber: Invoice['Number'] | undefined | null;
  newUserPassword: string;
  checkoutError: string | undefined | null;
  checkoutErrorsByField: {
    [fieldName: string]: string;
  };
  checkoutInProgress: boolean;
  checkoutComplete: boolean;
  checkoutSuccess: boolean;
  checkoutStarted: boolean;
  completedOrderNumber: Order['Number'] | undefined | null;
};
const defaultState = {
  newUserPassword: '',
  showInvoiceNumber: null,
  checkoutErrorsByField: {},
  checkoutInProgress: false,
  checkoutComplete: false,
  checkoutSuccess: false,
  checkoutStarted: false,
  checkoutError: null,
  completedOrderNumber: null,
};
export default function invoicePageReducer(
  state: InvoicePage = defaultState,
  action: Action,
): InvoicePage {
  switch (action.type) {
    case 'SHOW_INVOICE':
      return Object.assign({}, state, {
        showInvoiceNumber: action.invoiceNumber,
        checkoutInProgress: false,
        checkoutComplete: false,
        checkoutSuccess: false,
        checkoutStarted: false,
        checkoutError: null,
        checkoutErrorsByField: {},
      });
    case 'INVOICE_CHECKOUT_START':
      return Object.assign({}, state, {
        checkoutInProgress: true,
        checkoutComplete: false,
        checkoutStarted: true,
        checkoutError: null,
        checkoutErrorsByField: {},
      });
    case 'INVOICE_CHECKOUT_SUCCESS':
      return Object.assign({}, state, {
        checkoutInProgress: false,
        checkoutComplete: true,
        checkoutSuccess: true,
        checkoutStarted: false,
        checkoutError: null,
        checkoutErrorsByField: {},
        completedOrderNumber: action.completedOrderNumber,
      });
    case 'INVOICE_CHECKOUT_FAIL':
      return Object.assign({}, state, {
        checkoutInProgress: false,
        checkoutComplete: false,
        checkoutSuccess: false,
        checkoutStarted: false,
        checkoutError: action.message,
        checkoutErrorsByField: action.fieldErrors || {},
      });
    case 'SELECT_PAYMENT_INSTRUMENT':
      return Object.assign({}, state, {
        checkoutError: null,
      });
    case 'UPDATE_INVOICE_NEW_USER_PASSWORD':
      return {
        ...state,
        newUserPassword: action.password,
      };
    default:
      return state;
  }
}
